import { DEFAULT_CIPHERS } from "tls";
import { WalletEnum } from "./enum.constants";

export const STATUS_VM = {
    STATUS_FILL_GOODS: "STATUS_FILL_GOODS",
    STATUS_NOT_READY_GOODS: "STATUS_NOT_READY_GOODS",
    STATUS_MAINTENANCED: "STATUS_MAINTENANCED",
    VM_OPENING_SOON: "VM_OPENING_SOON",
    NO_INTERNET: "NO_INTERNET",
    NO_RABBIT: "NO_RABBIT",
    NOT_AVAILABLE: "NOT_AVAILABLE",
    BUSY: "BUSY",
    NO_BUSINESS: "NO_BUSINESS",
    NO_SYNCED_DATA: "NO_SYNCED_DATA",
    OFFLINE: "OFFLINE",
};

export const URL_BACKGROUND = {
    URL_LOADING_GOODS_BACKGROUND: "URL_LOADING_GOODS_BACKGROUND", // Link hình ảnh đang nạp hàng
    URL_DISCONNECT_BACKGROUND: "URL_DISCONNECT_BACKGROUND", // Link hình ảnh mất kết nối
    URL_COMMING_SOON_BACKGROUND: "URL_COMMING_SOON_BACKGROUND", // Link hình ảnh sắp bán hàng
    URL_OUT_OF_STOCK_BACKGROUND: "URL_OUT_OF_STOCK_BACKGROUND", // Link hình ảnh hết hàngLink hình ảnh hết hàng
    URL_MAINTAIN_EVENT: "URL_MAINTAIN_EVENT", // Link hình ảnh bảo trì
    URL_CHANNEL_BACKGROUND: "URL_CHANNEL_BACKGROUND", // Link hình ảnh chỉ thanh toán offline
};

export const STATUS_MONEY = {
    INPUT: "INPUT",
    REDEEM: "REDEEM",
    REFUND: "REFUND",
}

export const PARENT_TYPE = {
    PAYMENT_ORDER: "PAYMENT_ORDER",
    TOPUP_PHONE: "TOPUP_PHONE",
}

export const BILL_TYPE = {
    PAYMENT_ORDER: "PAYMENT_ORDER",
    TOPUP_TORO: "TOPUP_TORO",
    TOPUP_PHONE: "TOPUP_PHONE",
    TOPUP_CHARITY_FUND: "TOPUP_CHARITY_FUND",
    UNKNOW: "UNKNOW",
    AFTER_HANDLE: "AFTER_HANDLE",
    TOPUP_BANK: "TOPUP_BANK",
}


export const STATUS_DROPS_PRODUCT = {
    SUCCESS: "SUCCESS",
    REJECT: "REJECT",
    WAITING: "WAITING",
}

export const REASON_FAIL = {
    BUSY: "BUSY",
    OUT_STOCK: "OUT_STOCK",
    BOILER: "BOILER",
    OTHER: "OTHER",
}

export const STATUS_CONFIRM_DROP_PRODUCT = {
    REJECT: "REJECT",
    NO_DROP: "NO_DROP",
    DROP_ALL: "DROP_ALL",
    DROP_PARTIAL: "DROP_PARTIAL",
}

export const SUBSOURCE = {
    VM: "VM",
    POS: "POS",
    QA: "QA",
    NESCAFE: "NESCAFE",
    DIRECT: "Direct",
}

export const DISPLAY_TYPE = {
    PRODUCT: "PRODUCT",
    LAYOUT: "LAYOUT",
}

export const PRODUCT_SHOW_OPTION = {
    COMBO_ONLY: "COMBO_ONLY",
    SINGLE_PRODUCT_ONLY: "SINGLE_PRODUCT_ONLY",
    COMBO_AND_SINGLE: "COMBO_AND_SINGLE",
    POSTER_ONLY: "POSTER_ONLY",
}

export const VOUCHERSOURCE = {
    LOYALTY: "LOYALTY",
    VENDING: "VENDING",
}

export const SCOPE_APPLY_VOUCHER = {
    BILL: "BILL",
    PRODUCT: "PRODUCT",
}

export const POS = {
    EDC: "EDC",
}

export const VALUE_STATUS_VM = {
    MAINTENANCE: {
        MAINTENANCED: "MAINTENANCED",
        NOT_MAINTENANCED: "NOT_MAINTENANCED",
    },
    BUSINESS: {
        IN_BUSINESS: "IN_BUSINESS",
        STOPPED_BUSINESS: "STOPPED_BUSINESS",
        WAITING_BUSINESS: "WAITING_BUSINESS",
    },
    FILLING_GOODS: {
        IN_FILLING_GOODS: "IN_FILLING_GOODS",
        NOT_YET_FILLED_GOODS: "NOT_YET_FILLED_GOODS",
        FILLED_GOODS: "FILLED_GOODS",
    },
    GOODS: {
        ALL_GOODS_EXPIRED: "ALL_GOODS_EXPIRED",
        NORMAL: "NORMAL",
        NO_GOODS: "NO_GOODS",
    }
}

export const STATUS_VOUCHER = {
    INVALID: "INVALID",
    CHECKING: "CHECKING",
    VALID: "VALID",
    USED: "USED",
    EXPIRED: "EXPIRED",
    OUTOFVOUCHER: "OUTOFVOUCHER",
    OUT_OF_VOUCHER_IN_DAY: "OUT_OF_VOUCHER_IN_DAY",
    PRODUCTINVALID: "PRODUCTINVALID",
    VOUCHER_OUT_OF_PRODUCT: "VOUCHER_OUT_OF_PRODUCT",
    OUT_OF_VOUCHER_IN_WEEKLY: "OUT_OF_VOUCHER_IN_WEEKLY",
    OUT_OF_VOUCHER_IN_MONTHLY: "OUT_OF_VOUCHER_IN_MONTHLY",
    OUT_OF_VOUCHER_IN_DAY_AMOUNT: "OUT_OF_VOUCHER_IN_DAY_AMOUNT",
    OUT_OF_VOUCHER_IN_WEEKLY_AMOUNT: "OUT_OF_VOUCHER_IN_WEEKLY_AMOUNT",
    OUT_OF_VOUCHER_IN_MONTHLY_AMOUNT: "OUT_OF_VOUCHER_IN_MONTHLY_AMOUNT",
    OUT_OF_VOUCHER_IN_QUARTERLY: "OUT_OF_VOUCHER_IN_QUARTERLY",
    OUT_OF_VOUCHER_IN_QUARTERLY_AMOUNT: "OUT_OF_VOUCHER_IN_QUARTERLY_AMOUNT",
    AMOUNT_REMAINING_INVALID: "AMOUNT_REMAINING_INVALID",
    OUT_OF_VOUCHER_AMOUNT: "OUT_OF_VOUCHER_AMOUNT",
}

export const MIX_TYPE = {
    MIX: "MIX",
    NORMAL: "NORMAL",
}

export const MENU_TYPE = {
    TORO: "TORO",
    PHONE: "PHONE",
    CHARITY: "CHARITY",
}

export const REASON_BUY_GOODS_FAIL = {
    PICKER_HAS_GOODS: "PICKER_HAS_GOODS",
    NOT_ENOUGH_TEMPERATURE: "NOT_ENOUGH_TEMPERATURE",
    MACHINE_ALARM: "MACHINE_ALARM",
    OUT_OF_ICE: "OUT_OF_ICE",
    WASTE_WATER_FULL: "WASTE_WATER_FULL",
}


export const CATEGORY = {
    WALLET: "WALLET",
    BANK: "BANK",
    PROMOTION: "PROMOTION",
}

export const EWALLET_NUMBER_LIST = [
    7,
    6,
    4,
    1,
    8,
    9,
    13,
    16,
    17,
    18,
    20,
    22,
    26,
]

export const BANKING_NUMBER_LIST = [
    10,
    14,
    15,
    19,
    25,
]

export const EWALLET_LIST = [
    WalletEnum.ZALO,
    WalletEnum.MOMO,
    WalletEnum.GRAB,
    WalletEnum.TORO,
    WalletEnum.SHOPEEPAY,
    WalletEnum.SMARTPAY,
    WalletEnum.LOYALTY,
    WalletEnum.SHOPEEPAY_ONLINE,
    WalletEnum.MOCA_ONLINE,
    WalletEnum.SMARTPAY_ONLINE,
    WalletEnum.MOMO_ONLINE,
    WalletEnum.APPOTA_ONLINE,
    WalletEnum.VIETTELPAY_OFFLINE,
    WalletEnum.VIETTELPAY_ONLINE,
    WalletEnum.BEE_CLASS,
    WalletEnum.CASH_VOUCHER,
]

export const BANKING_LIST = [
    WalletEnum.CARDATM,
    WalletEnum.VNPAY,
    WalletEnum.VNPAY_ONLINE,
    WalletEnum.VNPT_ONLINE,
    WalletEnum.EDC_TPBANK,
]

export const TYPE_CAMMAND_W2A = {
    // Topup Toro trực tiếp
    W2A_TORO_OPEN_CASH: "W2A_TORO_OPEN_CASH",
    W2A_TORO_CONFIRM_TOPUP: "W2A_TORO_CONFIRM_TOPUP",
    W2A_TORO_CANCEL_TOPUP: "W2A_TORO_CANCEL_TOPUP",
    // Topup Phone trực tiếp
    W2A_PHONE_OPEN_CASH: "W2A_PHONE_OPEN_CASH",
    W2A_PHONE_CONFIRM_TOPUP: "W2A_PHONE_CONFIRM_TOPUP",
    W2A_PHONE_CANCEL_TOPUP: "W2A_PHONE_CANCEL_TOPUP",
    // Đóng góp từ thiện trực tiếp
    W2A_CHARITY_OPEN_CASH: "W2A_CHARITY_OPEN_CASH", // Mở cash để đóng từ thiện
    W2A_CHARITY_CONFIRM_TOPUP_DIRECT: "W2A_CHARITY_CONFIRM_TOPUP_DIRECT", // Xác nhận đóng góp từ thiện trực tiếp
    W2A_CHARITY_CANCEL_TOPUP_DIRECT: "W2A_CHARITY_CANCEL_TOPUP_DIRECT", // Cancel đóng góp từ thiện
    // Buy cash
    W2A_OPEN_BUY_CASH: "W2A_OPEN_BUY_CASH",
    W2A_CONFIRM_BUY_CASH: "W2A_CONFIRM_BUY_CASH",
    // Hủy ko mua hàng
    W2A_CANCEL_BUY_CASH: "W2A_CANCEL_BUY_CASH",
    // Yêu cầu đóng máy cash
    W2A_CLOSE_BUY_CASH: "W2A_CLOSE_BUY_CASH",
    // Nạp toro bằng tiền dư mua hàng
    W2A_BALANCE_TORO_CONFIRM_TOPUP: "W2A_BALANCE_TORO_CONFIRM_TOPUP",
    // Nạp bank bằng tiền dư mua hàng
    W2A_BALANCE_CONFIRM_TOPUP_BANK: "W2A_BALANCE_CONFIRM_TOPUP_BANK",
    // Nạp phone bằng tiền dư mua hàng
    W2A_BALANCE_PHONE_CONFIRM_TOPUP: "W2A_BALANCE_PHONE_CONFIRM_TOPUP",
    // Topup charity từ tiền dư
    W2A_CHARITY_CONFIRM_TOPUP: "W2A_CHARITY_CONFIRM_TOPUP",
    // Hủy tiền dư
    W2A_CANCEL_CASH_BALANCE: "W2A_CANCEL_CASH_BALANCE",
    // Clean tiền dư khi skill app
    W2A_CLEAN_MONEY_LEFT_OVER: "W2A_CLEAN_MONEY_LEFT_OVER",
    // Tiếp tục mua hàng
    W2A_CONTINUE_SHOPPING: "W2A_CONTINUE_SHOPPING",
    // Mất kết nối
    W2A_LOST_CONNECTION: "W2A_LOST_CONNECTION",
    // Click icon tiền dư
    W2A_CLICK_ICON_LEFTOVER: "W2A_CLICK_ICON_LEFTOVER",
    // Ghi log
    W2A_WRITE_LOG: "W2A_WRITE_LOG",
    // Ghi log
    W2A_START_PAYMENT: "W2A_START_PAYMENT",
    // Thông báo page đã render xong
    W2A_LOAD_PAGE_BILL_SUCCESS: "W2A_LOAD_PAGE_BILL_SUCCESS",
    // Start ads
    W2A_START_ADS: "W2A_START_ADS",
    // start game
    W2A_START_GAME: "W2A_START_GAME",
    // Stop game
    W2A_STOP_GAME: "W2A_STOP_GAME",
    // Kiểm tra mua hàng
    W2A_CHECK_BUY_GOODS: "W2A_CHECK_BUY_GOODS",
    // open page bill-success
    W2A_START_PAGE_BILL_SUCCESS: "W2A_START_PAGE_BILL_SUCCESS",
    // Thanh toán edc trên pos
    W2A_PAYMENT_EDC_POS: "W2A_PAYMENT_EDC_POS",
    // Bắt đầu mua hàng bằng cash trên POS
    W2A_PAYMENT_CASH_POS: "W2A_PAYMENT_CASH_POS",
    // Start lại web
    W2A_START_INIT_PAGE: "W2A_START_INIT_PAGE",
    // start camera
    W2A_START_CAMERA: "W2A_START_CAMERA",
    // start checl bill
    W2A_START_CHECK_BILL_STATUS: "W2A_START_CHECK_BILL_STATUS",
    // Lấy nước nóng
    W2A_GET_HOT_WATER: "W2A_GET_HOT_WATER",
    // Thông tin bill 
    W2A_RESPONSE_PAYMENT_OFFLINE: "W2A_RESPONSE_PAYMENT_OFFLINE",
    // yêu cầu rớt hàng khi part thanh toán xong
    W2A_RESPONSE_PAYMENT_PARTNER: "W2A_RESPONSE_PAYMENT_PARTNER",
}

export const TYPE_CAMMAND_A2W = {
    // Điều hướng đến trang rớt hàng
    A2W_START_BILL_SUCCESS: "A2W_START_BILL_SUCCESS",
    // Topup Toro
    A2W_TORO_INPUT_MONEY: "A2W_TORO_INPUT_MONEY",
    A2W_TORO_TOPUP_SUCCESS: "A2W_TORO_TOPUP_SUCCESS",
    A2W_TORO_TOPUP_FAIL: "A2W_TORO_TOPUP_FAIL",
    A2W_TORO_OPEN_CASH_FAIL: "A2W_TORO_OPEN_CASH_FAIL",
    // Topup Phone
    A2W_PHONE_INPUT_MONEY: "A2W_PHONE_INPUT_MONEY",
    A2W_PHONE_TOPUP_SUCCESS: "A2W_PHONE_TOPUP_SUCCESS",
    A2W_PHONE_TOPUP_FAIL: "A2W_PHONE_TOPUP_FAIL",
    A2W_PHONE_OPEN_CASH_FAIL: "A2W_PHONE_OPEN_CASH_FAIL",
    // Topup Charity
    A2W_CHARITY_INPUT_MONEY: "A2W_CHARITY_INPUT_MONEY", // Tiền nhét vào để đóng góp từ thiện
    A2W_CHARITY_TOPUP_DIRECT_SUCCESS: "A2W_CHARITY_TOPUP_DIRECT_SUCCESS", // Đóng góp từ thiện trực tiếp thành công
    A2W_CHARITY_TOPUP_DIRECT_FAIL: "A2W_CHARITY_TOPUP_DIRECT_FAIL", // Đóng góp từ thiện thất bại 
    A2W_CHARITY_OPEN_CASH_FAIL: "A2W_CHARITY_OPEN_CASH_FAIL", // Mở cash thất bại
    // Buy cash
    A2W_INPUT_MONEY: "A2W_INPUT_MONEY",
    A2W_OPEN_BUY_CASH_FAIL: "A2W_OPEN_BUY_CASH_FAIL",
    A2W_DROP_GOODS: "A2W_DROP_GOODS",
    A2W_RESULT_BUY_CASH: "A2W_RESULT_BUY_CASH",
    // Xóa tiền dư
    A2W_CLEAN_MONEY_LEFT_OVER: "A2W_CLEAN_MONEY_LEFT_OVER",
    // Thành công/ thất bai của nạp toro từ tiền dư 
    A2W_TORO_BALANCE_TOPUP_SUCCESS: "A2W_TORO_BALANCE_TOPUP_SUCCESS",
    A2W_TORO_BALANCE_TOPUP_FAIL: "A2W_TORO_BALANCE_TOPUP_FAIL",
    // Thành công/ thất bai
    A2W_BALANCE_TOPUP_BANK_SUCCESS: "A2W_BALANCE_TOPUP_BANK_SUCCESS",
    A2W_BALANCE_TOPUP_BANK_FAIL: "A2W_BALANCE_TOPUP_BANK_FAIL",
    // Thành công/ thất bai của nạp phone từ tiền dư 
    A2W_PHONE_BALANCE_TOPUP_SUCCESS: "A2W_PHONE_BALANCE_TOPUP_SUCCESS",
    A2W_PHONE_BALANCE_TOPUP_FAIL: "A2W_PHONE_BALANCE_TOPUP_FAIL",
    // Thành công/ thất bai của từ thiện từ tiền dư 
    A2W_CHARITY_BALANCE_TOPUP_SUCCESS: "A2W_CHARITY_BALANCE_TOPUP_SUCCESS",
    A2W_CHARITY_BALANCE_TOPUP_FAIL: "A2W_CHARITY_BALANCE_TOPUP_FAIL",
    // Reject bill 
    A2W_REJECT_BUY: "A2W_REJECT_BUY",
    // Bill info
    A2W_BILL_INFO: "A2W_BILL_INFO",
    // Stop ads
    A2W_STOP_ADS: "A2W_STOP_ADS",
    // Được phếp mua hàng ko
    A2W_RESULT_CHECK_BUY_GOODS: "A2W_RESULT_CHECK_BUY_GOODS",
    // Mua hàng MDB
    A2W_START_PAYMENT_MDB: "A2W_START_PAYMENT_MDB",
    // Từ chối mua hàng MBD
    A2W_END_PAYMENT_MDB: "A2W_END_PAYMENT_MDB",
    // Kết thúc mua hàng bằng cash trên POS
    A2W_END_PAYMENT_CASH_POS: "A2W_END_PAYMENT_CASH_POS",
    // Stop game có dánh sách sản phẩm
    A2W_STOP_GAME: "A2W_STOP_GAME",
    // Stop camera
    A2W_STOP_CAMERA: "A2W_STOP_CAMERA",
    // Stop check bill
    A2W_END_CHECK_BILL_STATUS: "A2W_END_CHECK_BILL_STATUS",
    // Máy cash đang có tiền vào
    HAS_EF_CODE_CASH: "HAS_EF_CODE_CASH",
    // App nhận được rabbit
    A2W_HAS_RABBIT_PAYMENT: "A2W_HAS_RABBIT_PAYMENT",
    // Rớt hàng offline
    A2W_REQUEST_PAYMENT_OFFLINE: "A2W_REQUEST_PAYMENT_OFFLINE",
    // Scan QRCODE
    A2W_SCAN_VOUCHER_CODE: "A2W_SCAN_VOUCHER_CODE",
}

export const STATUS_ACQUIRE_USER = {
    INVALID: "INVALID",
    VALID: "VALID",
    OVER_LIMIT: "OVER_LIMIT",
    SUCCESS: "SUCCESS",
    FAIL: "FAIL"
}

export const RESULT_CODE = {
    SUCCESS: "SUCCESS",
    FAIL: "FAIL",
}


export const GIFT_TYPE = {
    GIFTOUTLAYOUT: "GIFTOUTLAYOUT",
    PLAYGAME: "PLAYGAME",
}

export const OUT_LAYOUT_DISPLAY_TYPE = {
    TEXT: "TEXT",
    QR: "QR",
    TEXT_ONLY: "TEXT_ONLY",
}


export const MSG_CONFIG = {
    MSG_PROMOTION_CONDITIONAPPLY: "MSG_PROMOTION_CONDITIONAPPLY",
    MSG_PROMOTION_WIN: "MSG_PROMOTION_WIN",
    MSG_PROMOTION_LOSE: "MSG_PROMOTION_LOSE",
    MSG_PROMOTION_ONSCREEN: "MSG_PROMOTION_ONSCREEN"
}

export const CONTACT_CONFIG = {
    LICENSE: "© 2020 Bản quyền của CÔNG TY TNHH KOOTORO VIỆT NAM",
    NAME: "Công ty TNHH KOOTORO Việt Nam",
    ADDRESS: "Địa chỉ: 36 Đường D2, Phường Tăng Nhơn Phú A, TP.Thủ Đức, TP.HCM.",
    CERTIFICATE: "Giấy chứng nhận đăng ký doanh nghiệp 0313421775 do Sở Kế hoạch và Đầu tư TP. HCM cấp."
}


export const OWNER_TYPE = {
    COMPANY: "COMPANY",
    PARTNER: "PARTNER",
}

export const BUSINESS_TIMER = {
    OPEN_TIME: "06:00",
    CLOSE_TIME: "23:59",
}

export const WARNING_OPTION = {
    CONFIRM: "CONFIRM",
    ONLY_SHOW: "ONLY_SHOW",
}

export const GOODS_DROP_TYPE = {
    LEFT_FIRST: "LEFT_FIRST",
    BIG_QUANTITY_FIRST: "BIG_QUANTITY_FIRST",
    EXPIRE_FIRST: "EXPIRE_FIRST",
}


export const REASON_CASH_LEFT_OVER = {
    TIME_OUT: "TIME_OUT",
    CANCEL: "CANCEL",
    UNKNOW: "UNKNOW",
}

export const SALE_TYPE = {
    NORMAL: "NORMAL",
    LOCK: "LOCK",
    OUT_STOCK: "OUT_STOCK",
    EXPIRED: "EXPIRED",
}

export const REASON_DROP_GODDS = {
    PORT_NULL: "PORT_NULL",
    TIME_OUT: "TIME_OUT",
    PORT_INIT_FAIL: "PORT_INIT_FAIL",
    OPEN_FAIL: "OPEN_FAIL",
    NOT_SHIP: "NOT_SHIP",
    GOODS_NOT_DROP: "GOODS_NOT_DROP",
}

export const MINUS_WAREHOUSE = {
    MINUS: "MINUS",
    NOT_MINUS: "NOT_MINUS",
}

export const WATER_TYPE = {
    HOT: "HOT",
}

export const GENDER_LIST = [
    { code: "MALE", name: "Male", translate: "lbl_male" },
    { code: "FEMALE", name: "Female", translate: "lbl_female" },
    { code: "OTHER", name: "Other", translate: "lbl_other" },
]

export const LOCATION_CODE = {
    DEFAULT_CODE: "PL2025021200001",
    PRODUCT_LOCATION_CODE: "PL2025030600001",
    QA_LOCATION_CODE: "PL2025031100001",
}

export const ERROR_MESSAGE = {
    MACHINE_NOT_AVAILABLE: "msg_machine_not_available",
    ORDER_CREATED_FAIL: "msg_order_created_fail",
    PAYMENT_METHOD_ENABLED_FAIL: "msg_payment_method_enabled_fail",
}